<style>
	 @import '@/assets/css/custom.css';
</style>

<template>
    <div>
        <Breadcrumbs main="Product" title="Stock Logs" />

		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">
					<div class="card">
						<div class="card-body">

							<div class="col-md-12 project-list filter-sort">
								<div class="row">
									<div class="col-md-10">
										<div class="mm-cart-text">
											<div class="col-md-6">
												<table class="product_table">
													<thead style="font-size: medium;">
														<tr>
															<th>Product</th>
															<th style="text-align: left;">:</th>
															<td style="text-align: left;">{{ product.product_name }}</td>
														</tr> 

														<tr>
															<th>Current Stock</th>
															<th style="text-align: left;">:</th>
															<td style="text-align: left;">{{ product.current_stock }}</td>
														
														</tr> 
													</thead>
												</table>
											</div>
                                           
                                        </div>
									</div>
                                    <div class="col-md-2">
										<router-link to="/products" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</router-link>
										<!-- <a href="#" @click.prevent="$router.go(-1)" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</a> -->
                                    </div>
								</div>
							</div>

							<div class="col-md-12 project-list filter-sort">
								<div class="row">
									<div class="col-md-8 d-flex mt-2">
										<label class="d-flex listing-length ms-1"><span>Show</span>
											<select class="form-select" v-model="listing_length" @change="fetchStockLogs()">
												<option value="5">5</option>
												<option value="10">10</option>
												<option value="20">20</option>
											</select>
											<span>entries</span>
										</label>
									</div>
									
								</div>
							</div>

							<div class="table-responsive product-table">
								<table class="display" id="basic-1">
									<thead>
										<tr align="center">
                                            <th>Sl.No</th>  
                                            <th>Type</th>
											<th>Stock</th>
											<th>Remaining Stock</th>
											<th>Technician</th>
											<th>Updated By</th>
											<th>Updated On</th>
                                        </tr>
									</thead>
									<tbody v-if="Boolean(stock_logs.length)">
                                        <tr align="center" v-for="(stock, index) in stock_logs" :key="stock_logs.id">
                                            <td>{{ (from - 1) + index + 1 }}</td>
                                            <td>
												<span class="badge rounded-pill bg-success" v-if="stock.type === 1">Added</span>
												<span class="badge rounded-pill bg-warning" v-else-if="stock.type === 2">Outgoing</span>
												<span class="badge rounded-pill bg-danger" v-else>Romoved</span>												
											</td>
											<td>{{ stock.stock }}</td>
											<td>{{ stock.balance_stock }}</td>
											<td><span v-if="stock.technician_id">{{ stock.technician_name }}</span></td>
											<td>{{ stock.added_user_name }}</td>
											<td>{{ stock.converted_created_at }}</td>
                                        </tr>
                                    </tbody>
									<tbody v-else>
										<tr>
											<td colspan="6" class="text-center">No stock logs found</td>
										</tr>
									</tbody>
								</table>
							</div>

							<!----pagination starts --->
							<nav aria-label="Page navigation" class="mt-2">
								<ul class="pagination">
									<li class="page-item" v-for="(page, index) in pagination" :key="index" :class="[{ disabled: !page.url }, { active: page.active }]">
									<a class="page-link" href="#" @click.prevent="fetchStockLogs(page.url)" tabindex="-1">
										<span v-if="index === 0">Prev</span>
										<span v-else-if="index === pagination.length - 1">Next</span>
										<span v-else v-html="page.label"></span>
									</a>
									</li>
								</ul>
							</nav>
							<!----pagination ends --->
							
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
import Swal from '@/utils/swal';
import { get } from '@/utils/api';
import { routes } from '@/constants/routes';
import { onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { getCurrentInstance } from 'vue';

const { proxy } = getCurrentInstance();
const route = useRoute();
const router = useRouter();
const listing_length = ref(10);
const stock_product_id = route.query.id;
const stock_logs = ref([]);
const product = ref({});
const from = ref(null);
const to = ref(null);
const total = ref(null);
const pagination = ref({});

const fetchStockLogs = (url = null) => {

	const params = {
		product_id: stock_product_id,
		limit: listing_length.value
	}

	const requestUrl = url ?? routes.StockLogs;

	get(requestUrl, { params }, false)
	.then((response) => {
		if (response.status === 200) {
			console.log(response.data.data);
			product.value = response.data.data.product;
			stock_logs.value = response.data.data.stock_logs.data;
			pagination.value = response.data.data.stock_logs.links;
			from.value = response.data.data.stock_logs.from;
			to.value = response.data.data.stock_logs.to;
			total.value = response.data.data.stock_logs.total;
		} else {
			Swal.fire('', response.data.message || 'Failed to fetch stock logs', 'error');
		}
	})
	.catch((error) => {
		if (error.response?.status === 422) {
			Swal.fire('', error.response.message || 'Validation error', 'error');
		} else if (error.response?.status === 500) {
			Swal.fire('', error.response.statusText || 'Server error', 'error');
		} else if (error.response?.status === 401) {
			Swal.fire('', error.response.statusText || 'Unauthorized', 'error');
			router.push({ name: 'login' });
		} else {
			Swal.fire('', error.response.data?.message || 'Error occured', 'error');
		}
	});

};

onMounted(() => {
	fetchStockLogs();
});

</script>